import styled from "@emotion/styled";
import Select from "shared/components/Form/Select";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { BORDER, COLOR_GREY_5, COLOR_WHITE } from "shared/theme/colors";

export const StyledSelect = styled(Select)`
  &.MuiInput-root .MuiNativeSelect-select {
    padding: 0 2rem 0 1rem;
    border-radius: 0.5rem;
    height: 40px;
    background-color: ${COLOR_WHITE};
    border: ${BORDER(1, COLOR_GREY_5)};
  }
`;

export const StyledSection = styled(FlexCenter)`
  cursor: pointer;
`;
